<template>
  <div class="">
    <div v-if="label != null" class="flex items-center">
      <div class="label-standard">
        <RequiredAsterisk v-if="required"></RequiredAsterisk>
        {{ label }}
      </div>

      
      <div v-if="tooltip != null" class="ml-4">
        <div class="" v-tooltip.top="{ html: propertyKey + 'Tooltip' }">
          <img src="https://cdn2.iconfinder.com/data/icons/officeicons/PNG/48/Help.png" class="w-4" />
        </div>

        <div :id="propertyKey + 'Tooltip'" class="p-1">{{ tooltip }}</div>
      </div>
    </div>

    <div :class="{ relative : true, 'form-line' : label != null }">      
      <template v-if="suggestions != null && suggestions.length > 0">
        <v-autocomplete 
          :items="items" 
          :auto-select-one-item="false"
          v-model="item" 
          :get-label="getLabel" 
          :component-item='template' 
          @input="inputBlurred"
          @focus="suggest"
          @blur="inputBlurred"
          @change="suggest">
        </v-autocomplete>
      </template>

      <template v-else>
        <input type="text"
          class="input-standard"
          ref="value"
          v-model="localValue"
          v-on:blur="inputBlurred($event.target.value)"
          v-on:keyup="onKeyup != null ? onKeyup($event.target.value) : false"
          v-on:focus="inputFocused"
          :placeholder="placeholder" />
      </template>
    </div>

    <div v-if="subLabel != null" class="mt-1 text-gray-900">{{ subLabel }}</div>
  </div>
</template>

<script>
  
  import ItemTemplate     from './ItemTemplate.vue'
  import RequiredAsterisk from '@/shared/components/form/RequiredAsterisk'

  export default {

    components : {
      RequiredAsterisk
    },

    props : {

      objectType : {
        type    : String,
        required: false
      },

      objectId : {
        type    : Number,
        required: false
      },

      label : {
        type    : String,
        required: false
      },

      subLabel : {
        type    : String,
        required: false
      },

      tooltip : {
        type    : String,
        required: false
      },

      propertyKey : {
        type    : String,
        required: false
      },
      // Object name is required if data array consist of two different data model e.g "broker" & "user" and we use object name to specfiy for which model we are updating the data in this component.
      objectName : {
        type    : String,
        required: false
      },

      value : {
        // type    : String,
        required: false
      },

      updateValue : {
        type    : Function,
        required: false
      },

      index : {
        type    : Number,
        required: false,
      },

      copyFrom : {
        type    : String,
        required: false
      },

      hello : {
        type : String,
        required:false
      },

      // onKeyup is a function that will be called
      // for those cases where you need to do something
      // as the user types in
      onKeyup: {
        type : Function,
        required : false
      },

      placeholder: {
        type    : String,
        required: false
      },

      required : {
        type : Boolean,
        required : false
      },

      suggestions : {
        type : Array,
        required : false
      },

      required : {
        type    : Boolean,
        required: false,
        default : false
      }
    },

    watch: {
      value : {
        
        deep     : true,
        immediate: true,

        handler(newValue, oldValue) {
          this.localValue = newValue
        },

      },
    },

    data() {
      return {
        localValue : this.value,

        // item    : {id: 9, name: 'Lion', description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.'},
        item    : this.value != null ? { name : this.value } : null,
        items   : [],
        template: ItemTemplate
      }
    },

    methods : {

      // for some components, we are updating something that is repeated via v-for.
      // For example, addresses. An applicant has multiple addresses, so we do
      // <v-for address in addresses>
      //   <InputText address>
      // But when we are doing the autosave, we actually need to know which address we are
      // updating. We can do this via index, which is passed as a prop.
      // For some, it's not repeated, so we don't need the index. So, instead of going
      // directly to updateValue, we are going via "localUpdateValue, so that we can check
      // if index exists, or not
      localUpdateValue(key, value) {
        if(this.index != null) {
          this.updateValue(this.objectType, this.index, key, value);
        }

        else if(this.objectName != null) {
          this.updateValue(this.objectName, key, value);
        } 

        else {
          this.updateValue(key, value);
        }
      },

      copyValue(fromApplicantId, applicantIndex) {
        this.localValue = this.$store.state[this.$store.state.view + 'Module'].client.applicants[applicantIndex].person[this.copyFrom]
      },

      inputFocused() {
        this.visibility = true
      },

      inputBlurred(value) {
        this.visibility = false

        this.updateValue({
          objectType: this.objectType,
          objectId  : this.objectId,
          index     : this.index,
          key       : this.propertyKey,
          value     : value != null && typeof(value) == 'object' ? value.name : value
        })
      },

      getLabel (item) {
        if(item) {
          return item.name
        }

        return null
      },
      
      suggest(text) {
        this.items = this.suggestions.filter((item) => {
          return (new RegExp(text.toLowerCase())).test(item.name.toLowerCase())
        })
      }

    }

  }
</script>

<style>
  .v-autocomplete .v-autocomplete-input-group .v-autocomplete-input {
    @apply w-full border border-gray-600 p-3 text-sm;
  }

  .v-autocomplete .v-autocomplete-input-group .v-autocomplete-input:focus {
    @apply border-gray-700 bg-yellow-300;
  }

  .v-autocomplete-list {
    @apply w-full text-left;
    max-height:400px;
    overflow-y: auto;
    border-bottom: 1px solid #8995A0;
  }

  .v-autocomplete-list .v-autocomplete-list-item {
    cursor: pointer;
    background-color: #fff;
    padding:8px;
    border-bottom: 1px solid #8995A0;
    border-left: 1px solid #8995A0;
    border-right: 1px solid #8995A0;
  }

  .v-autocomplete-list .v-autocomplete-list-item:last-child {
    border-bottom:none;
  }

  .v-autocomplete-list .v-autocomplete-list-item:hover {
    background-color: #F7FF6A;
  }
    /*border none
    border-top none
    max-height 400px
    overflow-y auto
    border-bottom 1px solid #157977
    .v-autocomplete-list-item
      cursor pointer
      background-color #fff
      padding 10px
      border-bottom 1px solid #157977
      border-left 1px solid #157977
      border-right 1px solid #157977
      &:last-child
        border-bottom none
      abbr
        opacity 0.8
        font-size 0.8em
        display block
        font-family sans-serif*/
</style>